// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const WipClaims = t.struct({
    draft: t.Number,
    forwarded: t.Number,
    laborRateChange: t.Number,
    newClaims: t.Number,
    rejected: t.Number,
    returned: t.Number,
    revised: t.Number,
    selectedForAudit: t.Number,
    waitingForDealerInvoice: t.Number
}, {
    name: 'WipClaims',
    strict: true
});

export const getDefaultState = () => new WipClaims({
    draft: 0,
    forwarded: 0,
    laborRateChange: 0,
    newClaims: 0,
    rejected: 0,
    returned: 0,
    revised: 0,
    selectedForAudit: 0,
    waitingForDealerInvoice: 0
});

export default WipClaims;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/wip-claims.js